import React, { useState } from 'react';
import api from '../services/api';
import EntityPicker from './EntityPicker';

/**
 * Link an existing platform entity onto a case or actor (FK + EntityLink via PATCH).
 */
function LinkExistingEntity({
  mode, // 'indicator-to-case' | 'actor-to-case' | 'indicator-to-actor'
  caseId,
  actorId,
  onLinked,
  disabled = false,
}) {
  const [selected, setSelected] = useState(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const config = {
    'indicator-to-case': {
      types: ['indicator'],
      placeholder: 'Search indicators to attach to this case…',
      button: 'Link indicator',
      run: async (entity) => {
        const res = await api.patch(`/hdp/iocs/${entity.id}`, { case_id: caseId });
        return res.data;
      },
    },
    'actor-to-case': {
      types: ['actor'],
      placeholder: 'Search threat actors to attach to this case…',
      button: 'Link actor',
      run: async (entity) => {
        const res = await api.patch(`/hdp/actors/${entity.id}`, { case_id: caseId });
        return res.data;
      },
    },
    'indicator-to-actor': {
      types: ['indicator'],
      placeholder: 'Search indicators to attribute to this actor…',
      button: 'Link indicator',
      run: async (entity) => {
        const payload = { actor_id: actorId };
        if (caseId) payload.case_id = caseId;
        const res = await api.patch(`/hdp/iocs/${entity.id}`, payload);
        return res.data;
      },
    },
  }[mode];

  if (!config) return null;

  const submit = async (event) => {
    event.preventDefault();
    if (disabled || !selected) return;
    setSaving(true);
    setError('');
    try {
      const linked = await config.run(selected);
      setSelected(null);
      onLinked?.(linked);
    } catch (err) {
      setError(err.response?.data?.error || err.message || 'Failed to link entity');
    } finally {
      setSaving(false);
    }
  };

  return (
    <form className="link-existing-panel" onSubmit={submit}>
      <div className="link-existing-title">Link existing</div>
      <EntityPicker
        value={selected}
        onChange={setSelected}
        allowedTypes={config.types}
        placeholder={config.placeholder}
        disabled={disabled || saving}
      />
      {error && <p className="relationship-composer-error">{error}</p>}
      <button
        type="submit"
        className="btn btn-secondary"
        style={{ marginTop: '8px' }}
        disabled={disabled || saving || !selected}
      >
        {saving ? 'Linking…' : config.button}
      </button>
    </form>
  );
}

export default LinkExistingEntity;
